import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { Table } from '@/components/table/Table';

import { TMemberDetails } from '@/types/member';

import { SimpleCell } from '../table/bodyCells/SimpleCell';
import { HeadCell } from '../table/headCells/HeadCell';
import { extractTable } from './helpers';
import { styles } from './MemberModal.styles';

type TMemberTableProps = {
  values: TMemberDetails | unknown;
};

/**
 * What: the stations of a member with the permission level on each, inside the member modal.
 * Why: shows read-only rows. There is no `onRowClick`, so the shared Table gives the rows no hover
 * colour and no pointer (they only appear for a clickable row).
 * Constraints: `values` is untyped backend data and is read through `extractTable`.
 */
const MemberTable = ({ values }: TMemberTableProps) => {
  const { t } = useTranslation();

  const tableData = extractTable(values);

  return (
    <Box sx={styles.memberTable}>
      <Table
        data={tableData}
        headCells={() => [
          <HeadCell key="stations" value={{ label: t('members.columns.stations') }} />,
          <HeadCell key="permissionsLevel" value={{ label: t('members.columns.permissionLvl') }} />,
        ]}
        bodyCells={(vm) => [
          <SimpleCell key="stations" value={vm.title} />,
          <SimpleCell
            key="permissionsLevel"
            value={vm.admin ? t('members.roles.admin') : t('members.roles.member')}
          />,
        ]}
        stickyHeader
      />
    </Box>
  );
};

export default MemberTable;
